// extracted by mini-css-extract-plugin
export var bonus = "screen1-module--bonus--de5f3";
export var container = "screen1-module--container--bf7ed";
export var desc = "screen1-module--desc--645a3";
export var info = "screen1-module--info--adc47";
export var screen1 = "screen1-module--screen1--55e01";
export var type = "screen1-module--type--f0803";